const closeTransitionMs = 1000;
const openTransition =
  "height 0.5s ease-out, width 0.5s ease-out, opacity 0.5s ease-out";
const closeTransition =
  "height 0.66s ease-in, width 0.66s ease-in, opacity 0.66s ease-in";
const fallbackMaxHeight = "calc(100vh - var(--navbar-height))";

export {
  closeTransition,
  closeTransitionMs,
  fallbackMaxHeight,
  openTransition,
};
